import { FaWhatsapp } from "react-icons/fa";
import { PiInstagramLogo, PiPhoneCall, PiTiktokLogoLight } from "react-icons/pi";
import { Link } from "react-router-dom";
import { STORAGE_URL } from "../../utils/constants";
import './OfficeCard.css';
import { getOfficePhoneNumber, getOfficeWhatsAppNumber, handleInstagramLink, handleTikTokLink } from "../../utils/helpers";

function OfficeCard({office}) {
  return(
    <div className="card-office h-100">
      <div className="card-office-image-wrap">
        <Link to={`/office/${office.id}`}>
          <img
            className="card-office-image"
            src={ office.profile_picture_path ? STORAGE_URL+office.profile_picture_path : require('../../assets/images/default-office.png') }
            alt=""
          />
        </Link>
      </div>
      <div className="card-office-body">
        <h5 className="card-office-name">{office?.office?.name ?? office?.name}</h5>
        <div className="card-office-socials">
          <a href={"https://wa.me/"+getOfficeWhatsAppNumber(office)} className="card-office-social-btn">
            <FaWhatsapp size={20} />
          </a>
          <a href={"tel:"+getOfficePhoneNumber(office)} className="card-office-social-btn">
            <PiPhoneCall size={20} />
          </a>
          {office?.instagram_link?.trim() !== '' &&
            <a href={handleInstagramLink(office?.instagram_link)} target="_blank" rel="noopener noreferrer" className="card-office-social-btn">
              <PiInstagramLogo size={20} />
            </a>
          }
          {office?.tiktok_link?.trim() !== '' &&
            <a href={handleTikTokLink(office?.tiktok_link)} target="_blank" rel="noopener noreferrer" className="card-office-social-btn">
              <PiTiktokLogoLight size={20} />
            </a>
          }
        </div>
      </div>
    </div>
  );
}

export default OfficeCard;
